import React, { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../../contexts/AdminAuthContext';
import adminApiClient from '../../api/adminAxios';

// Story 28 — deliberately plain/unbranded (internal tool, not the customer-facing app).
function AdminLogin() {
  const navigate = useNavigate();
  const auth = useAdminAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  if (auth.isAuthenticated) {
    return <Navigate to="/iseeallnomisses/console" replace />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await adminApiClient.post('/api/admin/login', { username: username.trim(), password });
      if (res.data?.token) {
        auth.login(res.data.token);
        navigate('/iseeallnomisses/console');
      }
    } catch (err) {
      setError('Invalid admin credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-900 px-4">
      <div className="w-full max-w-sm bg-slate-800 rounded-lg border border-slate-700 p-6">
        <h1 className="text-lg font-semibold text-slate-100 mb-4">Platform Admin</h1>
        {error && (
          <div className="mb-4 rounded border border-red-700 bg-red-950 px-3 py-2 text-sm text-red-300">
            {error}
          </div>
        )}
        <form onSubmit={handleSubmit}>
          <label className="block text-xs font-medium text-slate-400 mb-1" htmlFor="admin-username">
            Username
          </label>
          <input
            id="admin-username"
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="w-full mb-3 px-3 py-2 rounded border border-slate-600 bg-slate-900 text-slate-100 outline-none focus:ring-2 focus:ring-slate-500"
            autoComplete="username"
            disabled={loading}
          />
          <label className="block text-xs font-medium text-slate-400 mb-1" htmlFor="admin-password">
            Password
          </label>
          <input
            id="admin-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full mb-4 px-3 py-2 rounded border border-slate-600 bg-slate-900 text-slate-100 outline-none focus:ring-2 focus:ring-slate-500"
            autoComplete="current-password"
            disabled={loading}
          />
          <button
            type="submit"
            disabled={loading}
            className="w-full rounded bg-slate-100 text-slate-900 font-medium py-2 hover:bg-white disabled:opacity-60"
          >
            {loading ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default AdminLogin;
